import { z } from 'zod';
export const activationSchema = z.object({
    password: z.string().min(12).max(256),
});
